/* eslint 'global-require': 'off' */
require('./util/custom-extend');

const doVueRender = () => {
    if (window.zxyCustomModules) {
        // 加载定制化的app.js
        window.customRequire('app').then(() => {
            require('./enter').default.setup();
        }, () => {
            require('./enter').default.setup();
        });
    } else {
        require('./enter').default.setup();
    }
};

const timeID = setInterval(() => {
    if (window.zxyAsyncLoadEnd) { // 黑箱初始化完成
        clearInterval(timeID);
        doVueRender(); // 开始渲染整个项目
    }
}, 50);
